import { createFileRoute } from "@tanstack/react-router";
import { SpaceDashboard } from "@/modules/chat/components/SpaceDashboard";

/**
 * Дашборд пространства — главный экран по адресу `/spaces/:id`.
 *
 * Сидит под `_app`-лейаутом: общий sidebar и auth-гейт приходят из
 * родителя, поэтому wrapper остаётся тонким — синхронизация
 * `currentSpaceId` со стором и инвалидация space-scoped кэшей живут
 * внутри `SpaceDashboard`.
 */
export const Route = createFileRoute("/_app/spaces/$id")({
  component: SpaceRoute,
});

function SpaceRoute() {
  const { id } = Route.useParams();
  return <SpaceDashboard spaceId={id} />;
}
